
const { render } = wp.element; //we are using wp.element here!

//import { createRoot } from "@wordpress/element"; //we are using wp.element here!
// import LabelCockpit from "./pages/LabelCockpit";
// import LabelSingle from "./pages/LabelSingle";
//import { createRoot } from 'react-dom/client';
import Filter from "./components/Filter";

var a = document.querySelectorAll("[trojniak-module-id]");
//console.log(a);
for (var i in a)
  if (a.hasOwnProperty(i)) {
    // Get the value of data attribute for current element in the loop
    var trojniak_module = a[i].getAttribute("trojniak-module-id");
    var trojniak_id = a[i].getAttribute("id");
    var params_json = a[i].getAttribute("data-trojniak-params");
    var params = JSON.parse(params_json);
    //console.log('trojniak_id:',document.getElementById(trojniak_id));
    const container = document.getElementById(trojniak_id);
    //const root = createRoot(container); // createRoot(container!) if you use TypeScript
    //console.log('root:',root);
    //console.log(trojniak_id, trojniak_module);
    if (document.getElementById(trojniak_id)) {
      //check if element exists before rendering
      //console.log("rendering");
      switch (trojniak_module) {
        case "filter":
          //const root = createRoot(container); // createRoot(container!) if you use TypeScript
          //root.render(<p>adf</p>);
            render(
              <Filter params={params} />,
              document.getElementById(trojniak_id)
            );
          break;

        default:
          //const root = createRoot(container); // createRoot(container!) if you use TypeScript
          //root.render(<p>test</p>);
          render(<p>TEST</p>, document.getElementById(trojniak_id));
          break;
      }
    }
  }
